import { queryKeys } from '../../queryKeys';
import { useQuery } from '../base';

/** The membership's currently effective Terms of Use, resolved by the
 * specific recurring `UserMembership` a client holds. */
export default function useUserMembershipTermsOfUse({
  organizationId,
  clientId,
  userMembershipId,
  enabled = true,
}: {
  organizationId?: string;
  clientId?: string;
  userMembershipId?: string;
  enabled?: boolean;
}) {
  const { queryFn, queryKey } =
    queryKeys.membershipTermsOfUse.fetchForUserMembership({
      organizationId: organizationId ?? '',
      clientId: clientId ?? '',
      userMembershipId: userMembershipId ?? '',
    });
  return useQuery({
    enabled: enabled && Boolean(organizationId && clientId && userMembershipId),
    queryFn,
    queryKey,
  });
}
